import React from 'react';

const StatsTitle = () => {
	document.title = 'Statistiques'
  return (
    <span>{document.title}</span>
  )
};

export default StatsTitle;